import React from "react";
import {DowntimeAct, DowntimeActStatus} from "../../../../../model/downtime-act/DowntimeAct";
import {BlockForDisplayingText} from "../../../../production-order/form/BlockForDisplayingText";
import {useUpdateDowntimeActStatusMutation} from "../../../../../store/backend-api/backend.api";
import {TfiPencil} from "react-icons/tfi";

interface Props {
    downtimeAct: DowntimeAct;
    isEditableDowntimeAct: boolean;
    setEditableDowntimeAct: (act: DowntimeAct) => void;
}

export const DowntimeActDescription = ({downtimeAct, isEditableDowntimeAct, setEditableDowntimeAct}: Props) => {
    const [doUpdateDowntimeActStatus] = useUpdateDowntimeActStatusMutation();

    const onChangeCheckboxValue = (event: React.ChangeEvent<HTMLInputElement>) => {
        doUpdateDowntimeActStatus({ number: downtimeAct.documentNumber, body: { status: event.target.checked ? DowntimeActStatus.CAUSE_ELIMINATED : DowntimeActStatus.NOTIFICATION }});
    };

    return (
        <div className='flex flex-col w-full'>
            <div className='flex justify-between w-[423px]'>
            <div className='flex gap-x-3 ml-0.5'>
                {downtimeAct.documentNumber}
                {!isEditableDowntimeAct && <TfiPencil className="mt-[1px] h-4 w-4 hover:text-blue-900"
                                                      title='Редактировать'
                                                      onClick={() => setEditableDowntimeAct(downtimeAct)}/>}
            </div>
            <div className='text-black/[.60]' title='Дата создания'>{downtimeAct.notificationTime}</div></div>
            <div className='flex justify-between items-center'>
                <BlockForDisplayingText text={downtimeAct.description} />
                <input type='checkbox' checked={downtimeAct.status === DowntimeActStatus.CAUSE_ELIMINATED} title='Причина устранена' onChange={onChangeCheckboxValue} className='h-5 w-5' />
            </div>
        </div>
    );
};